import Holidays from "date-holidays";

const publicHolidaysMap = {
	US: [
		{
			name: "Washington's Birthday",
			localName: "President's Day",
		},
	],
};

const getPublicHolidays = (countryCode) => publicHolidaysMap[countryCode] || [];

const getPublicHolidayName = (holiday, countryCode = "US") => {
	const publicHolidays = getPublicHolidays(countryCode);
	return publicHolidays.find((item) => item.name === holiday)?.localName || holiday;
};

const getFormattedHolidays = (holidays = [], countryCode = "US") =>
	holidays.map((item) => ({
		date: new Date(item.date),
		holidayName: item.name,
		localHolidayName: getPublicHolidayName(item.name, countryCode),
	}));

const getHolidays = (year, countryCode = "US") => {
	const HolidaysInterface = new Holidays(countryCode, { types: ["public"] });
	const holidays = HolidaysInterface.getHolidays(year);
	return getFormattedHolidays(holidays, countryCode);
};

export { getHolidays };
